<script>
  import { countries, euCountries, gdpr } from '../constants';
  import { sanitizeDomain, validateDomain, hubspotLeadSubmit } from '../util';
  import { dkimLookup } from '../api.js';
  import { onMount } from 'svelte';


  let error = false;
  let loading = false;
  let inputSelector = '';
  let inputDomainName = '';
  let inputEmail = '';
  let inputCountry = '';
  let validForm = null;
  let formGUID = 'acba015d-5cb8-4cae-838e-aafdf858710a';
  let hubspotutk = '';
  let url = '';

  onMount(async () => {
    url = window.location.href;
    console.log('page url = ' + url);

    hubspotutk = getHubspotUtkCookie();
    console.log('hubspotutk = ' + hubspotutk);
  });

  $: validDomain = validateDomain(inputDomainName);
  $: isEUCountry = euCountries.includes(inputCountry);

  function lookupDomain() {
    inputSelector = sanitizeDomain(inputSelector);
    inputDomainName = sanitizeDomain(inputDomainName);

    validForm = inputDomainName != '' && inputEmail != '' && inputCountry != '';
    error = false;

    if (!validForm) return;

    if (validateDomain(inputDomainName)) {
      loading = true;
      let formValues = {
        'dkim_domain': inputDomainName,
        'email': inputEmail,
        'dkim_record_status': 'Record Found',
        'country': inputCountry,
      };

      let context = {
        "hutk": hubspotutk, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
        "pageUri": url,
        "pageName": "DKIM Lookup"
      };

      if (isEUCountry) {
        let gdprValues = [];
        Object.values(gdpr).forEach(item => {
          if (item.value == true) {
            gdprValues.push(item.text);
          }
        });
        formValues.gdpr_contact_methods = gdprValues.join('; ');
      }

      dkimLookup(inputDomainName, inputSelector).catch(err => {
        error = err.message;
        formValues.dkim_record_status = 'Record Not Found';
      });

      console.log(formValues);
      // Hubspot background submit.
      // @see https://developers.marketo.com/blog/make-a-marketo-form-submission-in-the-background/
      hubspotLeadSubmit(formValues, context, formGUID);
    }
  }

  const getHubspotUtkCookie = () => {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'hubspotutk') {
        return value;
      }
    }
    return null;
  };
</script>

<section class="tool-banner tool-banner-dkim mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <!-- <div class="row">
        <div class="col-12 m-auto banner-text">
          <h1>Look Up DKIM Records</h1>
          <p>DomainKeys Identified Mail uses your domain name to sign your emails with a digital signature that confirms your identity so your customers know the emails are really from you and haven’t been hijacked while in transit.</p>
        </div>
      </div> -->
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <form
              on:submit|preventDefault={lookupDomain}
              class="dkim-search"
            >
              <div class="row">
                <div class="col-sm-5">
                  <input
                    bind:value={inputSelector}
                    class="form-control form-control-lg"
                    name="selector"
                    placeholder="Selector"
                    maxlength="255"
                    type="text"
                    required
                  >
                </div>
                <button class="col-sm-2 btn btn-link" data-toggle="modal" data-target="#selectorModal">What is a selector?</button>
                <div class="modal fade" id="selectorModal" tabindex="-1" aria-labelledby="selectorModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="selectorModalLabel">What is a selector?</h5>
                        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-md col-12">
                            <div class="content">
                              <p>A 'selector' is mechanism to allow a single domain to have multiple keys. Some domains, like Twitter and eBay, use <mark>dkim</mark>. Google Apps domains typically use <mark>google</mark>. Others simply use <mark>default</mark> as a value.</p>
                              <p>If you have a message signed with a DKIM key, you can find the selector by looking at what is defined for the <mark>s=</mark> value in the<br> DKIM-Signature header. In this example, the selector for the domain agari.com is <mark>s1024</mark>:</p>
                            </div>

                          </div>
                          <div class="col-md col-12">
                            <div class="color-box">
                              <p>DKIM-Signature: v=1; a=rsa-sha256; c=relaxed/relaxed; d=agari.com; s=s1024;</p>
                              <p>h=mime-version:from:date:message-id:subject:to;[...]</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-3 col-sm-5">
                  <input
                  bind:value={inputEmail}
                  class="form-control form-control-lg"
                  name="email"
                  placeholder="Email address"
                  maxlength="255"
                  type="email"
                  required
                ></div>
              </div>
              <div class="row">
                <div class="mb-3 col-sm-6">
                  <input
                    bind:value={inputDomainName}
                    class="form-control form-control-lg"
                    name="domain_name"
                    placeholder="Enter your domain here..."
                    maxlength="255"
                    type="text"
                    title="Enter a fully qualified domain name"
                  >
                </div>
                <div class="mb-3 col-sm-6">
                  <select
                    bind:value={inputCountry}
                    class="form-control form-control-lg"
                    aria-label="Country"
                    required
                  >
                    <option value="" selected>Country</option>
                    {#each countries as country }
                      <option value={country}>{country}</option>
                    {/each}
                  </select>
                </div>
                {#if isEUCountry}
                  <div class="mb-3">
                    <p>We will use your data to provide you with information regarding your request. From time to time, we would like to contact you about our products and services, along with other content that may be of interest to you. If you consent to us contacting you for this purpose, please tick the options below.</p>
                    {#each Object.entries(gdpr) as [id, item]}
                      <div class="form-check">
                        <input bind:checked={item.value} class="form-check-input" type="checkbox" id="{id}">
                        <label class="form-check-label" for="{id}">
                          {item.text}
                        </label>
                      </div>
                    {/each}
                  </div>
                {/if}
                
              </div>
              <div class="text-center">
                <button
                  disabled={!validDomain || loading}
                  class:loading
                  class="btn btn-lg btn-1 mx-auto"
                  type="submit"
                >
                  Find Record
                </button>
              </div>
              {#if inputDomainName != '' && !validDomain}
                <div class="text-danger">Invalid domain name.</div>
              {/if}
              {#if validForm != null && !validForm}
                <div class="text-danger">All fields are required.</div>
              {/if}
              {#if error}
                <div class="text-danger">Invalid domain name.</div>
              {/if}
            </form>
          </div>
        </div>
      </div>
      {#if error}
        <div class="row">
          <div class="text-danger">{error}</div>
        </div>
      {/if}
    </div>
  </div>
</section>


<!-- <section class="section row bg-7">
	<div class="col-sm-12">
		<div class="container">
			<h2 class="section-title">
				DKIM and DMARC
			</h2>
			<p class="text-center">Get Agari’s spin on the benefits of DKIM validation</p>
			<p class="text-center mt-5"><a href="/resources/videos/bimi-crash-course" class="btn btn-1">Watch the Video</a></p>
		</div>
	</div>
</section> -->

<style>

</style>
